import React from 'react';
import { useTranslation } from '../App';

const Team = () => {
  const t = useTranslation();
  return (
    <section className="team">
      <div className="flex team-flex">
        <div>
          <span>{t.team.title}</span>
          <h3>{t.team.heading}</h3>
        </div>
        <div>
          <p>{t.team.description}</p>
        </div>
      </div>
      <div className="flex img-flex">
        {/* <img src="/assets/t1.jpeg" alt="Team" className="team-image" /> */}
      </div>
    </section>
  );
};

export default Team;